// DS-canonical warning icon: filled amber hazard triangle with a white "!".
// Used everywhere a warning appears (table rows, banners). See COMPONENTS.md.
export default function WarnIcon({ size = 20, className = "", ...rest }) {
  const style = size !== 20 ? { width: size, height: size } : undefined;
  const markStyle = size !== 20 ? { fontSize: Math.round(size * 0.55) } : undefined;
  return (
    <span className={`peb-warn-icon ${className}`} style={style} role="img" aria-label="warning" {...rest}>
      <span className="peb-warn-icon__tri" />
      <span className="peb-warn-icon__mark" style={markStyle}>!</span>
    </span>
  );
}
